module.exports = __webpack_public_path__ + "img/logo-circle.c084a627.svg";